import React, { FC, useCallback, useMemo, useState } from 'react';

import { DataGridProgressContext } from '../context/DataGridProgressContext';

const DataGridProgressProvider: FC = (props) => {
  const [visibility, setVisibility] = useState(false);
  const show = useCallback(() => {
    setVisibility(true);
  }, [setVisibility]);
  const hide = useCallback(() => {
    setVisibility(false);
  }, [setVisibility]);
  const value = useMemo(() => ({ visibility, show, hide }), [visibility, show, hide]);

  return <DataGridProgressContext.Provider value={value}>{props.children}</DataGridProgressContext.Provider>;
};

export default DataGridProgressProvider;
